import type { RibbonControlProps } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import { type MailRibbonControlId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { RibbonControlId } from "owa-ribbon-ids";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { debugErrorThatWillShowErrorPopupOnly } from "owa-trace";
import { getAdvancedSearchControl, getCloseSearchControl, getHasAttachmentRefinerControl, getIsUnreadRefinerControl, getIsMentionedRefinerControl, getIsMentionedInChatsRefinerControl, getIsFlaggedRefinerControl, getHighImportanceRefinerControl, getToMeRefinerControl, getDateRangeRefinerControl, getIncludeChannelsRefinerControl, getEntityAllControl, getEntityMailControl, getEntityChatsControl, getEntityFilesControl, getEntityPeopleControl, getSearchHighlightingControl, } from "../../sharedControls/readSharedControlDefinitions";

/**
 * This function supplies a mapping from RibbonControlId to their respective control definition function.
 * For any new control in a tab, be sure to update the mapping below.
 * Note: This function should *not* have any logic regarding showing/hiding.
 *       That should be in shouldShowRibbonControl.ts instead.
 */
export const getMLRSearchToolsTabControlDefinition: (controlId: RibbonControlId, _tabId: MailRibbonTabId, props: ReadOnlyRibbonControlDefProps) => RibbonControlProps | undefined = owaComputedFn(function getMLRSearchToolsTabControlDefinition(controlId: RibbonControlId, _tabId: MailRibbonTabId, props: ReadOnlyRibbonControlDefProps): RibbonControlProps | undefined {
    switch (controlId) {
        case 739:
            return getAdvancedSearchControl(props);
        case 740:
            return getCloseSearchControl(props);
        case 766:
            return getSearchHighlightingControl(props);
        case 741:
            return getHasAttachmentRefinerControl(props);
        case 742:
            return getIsUnreadRefinerControl(props);
        case 743:
            return getIsMentionedRefinerControl(props);
        case 744:
            return getIsMentionedInChatsRefinerControl(props);
        case 745:
            return getIsFlaggedRefinerControl(props);
        case 746:
            return getHighImportanceRefinerControl(props);
        case 747:
            return getToMeRefinerControl(props);
        case 748:
            return getDateRangeRefinerControl(props);
        case 749:
            return getIncludeChannelsRefinerControl(props);
        case 754:
            return getEntityAllControl(props);
        case 750:
            return getEntityMailControl(props);
        case 751:
            return getEntityChatsControl(props);
        case 752:
            return getEntityFilesControl(props);
        case 753:
            return getEntityPeopleControl(props);
        default:
            debugErrorThatWillShowErrorPopupOnly("getMLRSearchToolsTabControlDefinition UnknownControl: " + controlId);
            return undefined;
    }
});
